import type { PersonDto } from "../../autogen/bff-api";

export const displayPersonNameWithEmail = (person: PersonDto): string => {
  const name = `${person.firstName ?? ""} ${person.lastName ?? ""}`;
  return person.email ? `${name} (${person.email})` : name.trim();
};

export const displayPersonName = (person: PersonDto): string => {
  return `${person.firstName ?? ""} ${person.lastName ?? ""}`;
};
